export default class Certificado {
    constructor(nome, validade, _id) {
        this.nome = nome;
        let bvenc = false;
        if(new Date() > new Date(validade)){
            bvenc = true;
        }
        this.validade = new Date(validade).toLocaleDateString();
        this.bvenc = bvenc;
        this._id = _id;
    }
}


// WEBPACK FOOTER //
// ./src/domain/conta/empresa/certificado/Certificado.js